/* The House of Majara: prototype interactions.
   Motion follows the brief: slow fades, no spring, no bounce, reduced motion respected.
   In Shopify, the cart functions map to the Ajax Cart API (/cart/add.js, /cart/change.js). */
(function () {
  "use strict";
  var doc = document.documentElement;
  doc.classList.add("js");
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var PRODUCTS = window.MAJARA_PRODUCTS || {};
  var inr = function (n) { return "₹" + n.toLocaleString("en-IN"); };
  var urlFor = function (h) { return PRODUCTS[h] && PRODUCTS[h].is_set ? "/collections/sets/#" + h : "/products/" + h + "/"; };

  /* ---------- Reveal on scroll entry. Safety net: nothing on or above the screen stays hidden. ---------- */
  var revealEls = $$(".reveal, .reveal-img, .reveal-fade");
  function revealPassed() {
    var vh = window.innerHeight;
    revealEls = revealEls.filter(function (el) {
      if (el.getBoundingClientRect().top < vh * 0.96) { el.classList.add("is-in"); return false; }
      return true;
    });
  }
  if (reduce || !("IntersectionObserver" in window)) {
    revealEls.forEach(function (el) { el.classList.add("is-in"); });
    revealEls = [];
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) { if (e.isIntersecting) { e.target.classList.add("is-in"); io.unobserve(e.target); } });
    }, { rootMargin: "0px 0px -4% 0px", threshold: 0 });
    revealEls.forEach(function (el) { io.observe(el); });
    revealPassed();
    window.addEventListener("load", revealPassed);
  }

  /* ---------- Text pages: "On this page" from the page's headings, the current one marked while reading ---------- */
  $$("[data-doc-toc]").forEach(function (toc) {
    var body = $(".doc__body, .shopify-policy__body");
    if (!body) return;
    // Pasted copy marks section titles as a bold line (<p><strong>…</strong></p>); give them real headings.
    $$("p", body).forEach(function (p) {
      var t = p.textContent.trim();
      var s = p.children.length === 1 && p.firstElementChild.tagName === "STRONG" && p.firstElementChild.textContent.trim() === t;
      if (!s || !t || t.length > 80) return;
      var h = document.createElement("h2");
      h.textContent = t;
      p.parentNode.replaceChild(h, p);
    });
    var heads = $$("h2", body);
    // The page head already shows the title; drop it when the text repeats it as its first heading.
    var key = function (t) { return t.trim().toLowerCase().replace(/[.\s]+$/, ""); };
    var h1 = $("h1");
    if (heads[0] && h1 && key(heads[0].textContent) === key(h1.textContent)) heads.shift().remove();
    if (heads.length < 3) return;
    var list = $("ol", toc);
    var links = heads.map(function (h, i) {
      if (!h.id) h.id = (h.textContent.trim().toLowerCase().replace(/^\d+\.\s*/, "").replace(/[^a-z0-9]+/g, "-").replace(/^-|-$/g, "") || "section") + "-" + (i + 1);
      var li = document.createElement("li");
      var a = document.createElement("a");
      a.href = "#" + h.id;
      a.textContent = h.textContent.trim();
      li.appendChild(a); list.appendChild(li);
      return a;
    });
    toc.hidden = false;
    if (!("IntersectionObserver" in window)) return;
    var mark = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (!e.isIntersecting) return;
        links.forEach(function (a) { a.removeAttribute("aria-current"); });
        links[heads.indexOf(e.target)].setAttribute("aria-current", "location");
      });
    }, { rootMargin: "0px 0px -70% 0px", threshold: 0 });
    heads.forEach(function (h) { mark.observe(h); });
  });

  /* ---------- Header: the masthead stays put; the slim bar slides in on scroll up ---------- */
  var mast = $("[data-masthead]");
  var bar = $("[data-bar]");
  var header = bar; // overlays (mega menu) pin the bar open while in use
  var lastY = window.scrollY;
  function setBar(show) {
    if (!bar || bar.classList.contains("is-shown") === show) return;
    bar.classList.toggle("is-shown", show);
    if (show) bar.removeAttribute("inert"); else bar.setAttribute("inert", "");
  }
  function onScrollHeader() {
    if (!bar) return;
    var y = Math.max(window.scrollY, 0);
    var mastBottom = mast ? mast.offsetTop + mast.offsetHeight : 0;
    if (bar.classList.contains("is-open") || document.body.style.overflow === "hidden") { lastY = y; return; }
    if (y < mastBottom + 120) setBar(false);
    else if (y > lastY + 6) setBar(false);
    else if (y < lastY - 6) setBar(true);
    lastY = y;
  }

  /* ---------- Pinned collection scroll (Awaken collection_scroll) ---------- */
  var cs = $("[data-cscroll]");
  var csMq = window.matchMedia("(max-width: 860px), (max-height: 680px)");
  function csFits() {
    // Pin only when every card fits inside the panel; otherwise use the swipe row so nothing is cut off.
    if (!cs) return false;
    cs.classList.remove("cscroll--static");
    if (reduce || csMq.matches) return false;
    var panel = $(".cscroll__panel", cs);
    var ok = panel.scrollHeight <= panel.clientHeight + 1;
    cs.classList.toggle("cscroll--static", !ok);
    return ok;
  }
  var csPinned = csFits();
  window.addEventListener("resize", function () { csPinned = csFits(); });
  window.addEventListener("load", function () { csPinned = csFits(); onScrollCs(); });
  if (document.fonts && document.fonts.ready) document.fonts.ready.then(function () { csPinned = csFits(); });
  function onScrollCs() {
    if (!cs || !csPinned) return;
    var track = $(".cscroll__track", cs), panel = $(".cscroll__panel", cs);
    var r = cs.getBoundingClientRect(), span = cs.offsetHeight - window.innerHeight;
    var p = Math.min(Math.max(-r.top / span, 0), 1);
    var max = Math.max(track.scrollWidth - panel.clientWidth, 0);
    track.style.transform = "translate3d(" + (-p * max).toFixed(1) + "px,0,0)";
    var arts = $$(".cscroll__art [data-name]", cs), n = arts.length;
    var idx = Math.min(n - 1, Math.floor(p * n * 0.999));
    if (cs._idx !== idx) {
      cs._idx = idx;
      arts.forEach(function (a, i) { a.classList.toggle("is-active", i === idx); });
      $$(".cscroll__pager span", cs).forEach(function (s, i) { s.classList.toggle("is-active", i === idx); });
      var nm = $(".cscroll__name", cs); nm.textContent = arts[idx].getAttribute("data-name");
      $(".cscroll__place", cs).textContent = arts[idx].getAttribute("data-place");
    }
  }

  /* ---------- Parallax: hero and banner images only, never text ---------- */
  var parallax = reduce ? [] : $$("[data-parallax]");
  function onScrollParallax() {
    var vh = window.innerHeight;
    parallax.forEach(function (el) {
      var host = el.parentElement.getBoundingClientRect();
      if (host.bottom < 0 || host.top > vh) return;
      if (el.dataset.parallax === "float") {
        var f = (host.top + host.height / 2 - vh / 2) / vh;
        el.style.transform = "translate3d(0," + (f * -(+el.dataset.speed || 60)).toFixed(1) + "px,0)";
        return;
      }
      if (el.dataset.parallax === "scale") {
        var p = Math.min(Math.max(-host.top / host.height, 0), 1);
        el.style.transform = "scale(" + (1 + p * 0.15).toFixed(4) + ")";
      } else {
        var c = Math.max(-1, Math.min(1, (host.top + host.height / 2 - vh / 2) / vh));
        el.style.transform = "translate3d(0," + (c * -6).toFixed(2) + "%,0)";
      }
    });
  }
  var ticking = false;
  window.addEventListener("scroll", function () {
    onScrollHeader(); // cheap, runs on every scroll event so the header always responds
    if (ticking) return;
    ticking = true;
    requestAnimationFrame(function () { revealPassed(); onScrollParallax(); onScrollSticky(); onScrollCs(); ticking = false; });
  }, { passive: true });

  /* ---------- Home hero carousel: fade 1400 ms, autoplay 8000 ms, pause on hover ---------- */
  var hero = $(".hero[data-hero]");
  if (hero) {
    var slides = $$(".hero__slide", hero);
    var pager = $$(".hero__pager button", hero);
    var idx = 0, timer = null;
    var go = function (n) {
      if (!slides[idx] || !pager[idx]) return;
      slides[idx].classList.remove("is-active");
      pager[idx].setAttribute("aria-current", "false");
      idx = (n + slides.length) % slides.length;
      slides[idx].classList.add("is-active");
      pager[idx].setAttribute("aria-current", "true");
    };
    var play = function () { if (!reduce) { stop(); timer = setInterval(function () { go(idx + 1); }, 8000); } };
    var stop = function () { if (timer) clearInterval(timer); timer = null; };
    pager.forEach(function (b, i) { b.addEventListener("click", function () { go(i); play(); }); });
    hero.addEventListener("mouseenter", stop);
    hero.addEventListener("mouseleave", play);
    play();
  }

  /* ---------- Overlays: mega menu, mobile menu, search, cart ---------- */
  var scrim = $(".scrim");
  var openLayer = null;
  function closeLayer() {
    if (!openLayer) return;
    openLayer.el.classList.remove("is-open");
    if (openLayer.trigger) openLayer.trigger.setAttribute("aria-expanded", "false");
    if (scrim) scrim.classList.remove("is-open");
    if (header) header.classList.remove("is-open");
    if (mast) mast.classList.remove("is-mega");
    document.body.style.overflow = ""; if (window.__lenis) window.__lenis.start();
    var t = openLayer.trigger; openLayer = null;
    if (t) t.focus({ preventScroll: true });
  }
  function openLayerEl(el, trigger, opts) {
    if (openLayer && openLayer.el === el) return;
    closeLayer();
    el.classList.add("is-open");
    if (trigger) trigger.setAttribute("aria-expanded", "true");
    if (opts && opts.scrim && scrim) scrim.classList.add("is-open");
    if (opts && opts.lock) { document.body.style.overflow = "hidden"; if (window.__lenis) window.__lenis.stop(); }
    openLayer = { el: el, trigger: trigger };
    var f = opts && opts.focus ? $(opts.focus, el) : null;
    if (f) setTimeout(function () { f.focus(); }, 60);
  }
  document.addEventListener("keydown", function (e) { if (e.key === "Escape") closeLayer(); });
  if (scrim) scrim.addEventListener("click", closeLayer);
  $$("[data-close]").forEach(function (b) { b.addEventListener("click", closeLayer); });

  // Mega menu under The Collection: hover on desktop, click or keyboard too.
  var mega = $(".mega");
  $$("[data-mega-trigger]").forEach(function (megaBtn) {
    if (!mega) return;
    var hideT;
    var show = function () {
      clearTimeout(hideT);
      var host = megaBtn.closest("[data-bar], [data-masthead]");
      openLayerEl(mega, megaBtn); // closes any other layer first, so mark the host after
      if (host === header) header.classList.add("is-open"); else host.classList.add("is-mega");
      mega.style.setProperty("--mega-top", Math.max(0, host.getBoundingClientRect().bottom) + "px");
    };
    var hide = function () { hideT = setTimeout(function () { if (openLayer && openLayer.el === mega) closeLayer(); }, 220); };
    megaBtn.addEventListener("mouseenter", show);
    megaBtn.addEventListener("mouseleave", hide);
    mega.addEventListener("mouseenter", function () { clearTimeout(hideT); });
    mega.addEventListener("mouseleave", hide);
    megaBtn.addEventListener("click", function (e) {
      if (window.matchMedia("(hover: hover)").matches && openLayer && openLayer.el === mega) return;
      e.preventDefault();
      if (openLayer && openLayer.el === mega) closeLayer(); else show();
    });
  });

  // The masthead and the slim bar each have a Menu button.
  var menu = $(".menu-overlay");
  $$("[data-menu-trigger]").forEach(function (menuBtn) {
    if (menu) menuBtn.addEventListener("click", function () { openLayerEl(menu, menuBtn, { lock: true, focus: "a" }); });
  });

  /* ---------- Search: places and notes ---------- */
  var searchEl = $(".search");
  $$("[data-search-trigger]").forEach(function (b) {
    b.addEventListener("click", function () { openLayerEl(searchEl, b, { scrim: true, focus: "input" }); });
  });
  var sInput = $(".search__input");
  var sDefault = $("[data-search-default]");
  var sResults = $("[data-search-results]");
  var sTimer;
  if (sInput) {
    sInput.addEventListener("input", function () {
      var q = sInput.value.trim();
      clearTimeout(sTimer);
      if (!q) { sDefault.hidden = false; sResults.hidden = true; return; }
      sTimer = setTimeout(function () {
        var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
        fetch(root + "search/suggest.json?q=" + encodeURIComponent(q) + "&resources[type]=product&resources[limit]=6")
          .then(function (r) { return r.json(); })
          .then(function (j) {
            var hits = (j.resources && j.resources.results && j.resources.results.products) || [];
            sDefault.hidden = true; sResults.hidden = false;
            sResults.innerHTML = hits.length
              ? '<div><p class="label">Fragrances</p><ul>' + hits.map(function (p) { var d = document.createElement("div"); d.textContent = p.title; return '<li><a href="' + p.url + '">' + d.innerHTML + "</a></li>"; }).join("") + "</ul></div>"
              : '<p class="lede">Nothing found for that. Try a place, like Konark, or a note, like sandalwood.</p>';
          }).catch(function () {});
      }, 200);
    });
  }

  /* ---------- Cart: Shopify Ajax Cart API (/cart.js, /cart/add.js, /cart/change.js) ---------- */
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || "/";
  var money = function (cents) { return "₹" + (cents / 100).toLocaleString("en-IN", { maximumFractionDigits: 0 }); };
  var drawer = $(".drawer");
  var dBody = $("[data-cart-body]");
  var dFoot = $("[data-cart-foot]");
  var dSub = $("[data-cart-subtotal]");
  var dEmptyUrl = (drawer && drawer.getAttribute("data-empty-url")) || root + "collections/all";
  var esc = function (t) { var d = document.createElement("div"); d.textContent = t == null ? "" : String(t); return d.innerHTML; };
  function jsonFetch(url, opts) {
    return fetch(root + url, Object.assign({ headers: { "Content-Type": "application/json", Accept: "application/json" } }, opts || {}))
      .then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
  }
  function render(cart) {
    $$("[data-cart-count]").forEach(function (el) { el.textContent = cart.item_count; });
    if (!dBody) return;
    if (!cart.item_count) {
      dBody.innerHTML = '<div class="drawer__empty"><p class="lede">Nothing here yet. A place is waiting.</p><p style="margin-top:28px"><a class="cta" href="' + esc(dEmptyUrl) + '">Continue exploring</a></p></div>';
      dFoot.hidden = true; return;
    }
    dFoot.hidden = false;
    dBody.innerHTML = cart.items.map(function (l, i) {
      var img = l.image ? l.image + (l.image.indexOf("?") > -1 ? "&" : "?") + "width=200" : "";
      return '<div class="line-item"><a class="media" href="' + l.url + '">' + (img ? '<img src="' + img + '" alt="">' : "") + '</a>' +
        '<div><a class="line-item__name" href="' + l.url + '">' + esc(l.product_title) + '</a>' +
        '<div class="line-item__meta">' + esc(l.variant_title || "") + '</div>' +
        '<div class="line-item__qty"><button type="button" data-line="' + (i + 1) + '" data-q="' + (l.quantity - 1) + '" aria-label="Decrease quantity">−</button><span>' + l.quantity + '</span><button type="button" data-line="' + (i + 1) + '" data-q="' + (l.quantity + 1) + '" aria-label="Increase quantity">+</button></div>' +
        '<button type="button" class="line-item__remove" data-line="' + (i + 1) + '" data-q="0">Remove</button></div>' +
        '<div class="line-item__price">' + money(l.final_line_price) + '</div></div>';
    }).join("");
    dSub.textContent = money(cart.total_price);
  }
  function refresh() { return jsonFetch("cart.js").then(render).catch(function () {}); }
  function openCart(trigger) { if (drawer) openLayerEl(drawer, trigger, { scrim: true, lock: true, focus: ".drawer__head button" }); }
  function add(variantId, q, trigger) {
    if (trigger) trigger.setAttribute("aria-busy", "true");
    return jsonFetch("cart/add.js", { method: "POST", body: JSON.stringify({ items: [{ id: +variantId, quantity: q }] }) })
      .then(refresh).then(function () { openCart(trigger); })
      .catch(function (err) { alert((err && (err.description || err.message)) || "This could not be added. Please try again."); })
      .then(function () { if (trigger) trigger.removeAttribute("aria-busy"); });
  }
  if (dBody) {
    dBody.addEventListener("click", function (e) {
      var t = e.target.closest("[data-line]"); if (!t) return;
      jsonFetch("cart/change.js", { method: "POST", body: JSON.stringify({ line: +t.getAttribute("data-line"), quantity: +t.getAttribute("data-q") }) })
        .then(function (cart) { if ($("[data-cart-page]")) location.reload(); else render(cart); }); // the cart page is server-rendered
    });
  }
  $$("[data-cart-trigger]").forEach(function (b) { b.addEventListener("click", function (e) { e.preventDefault(); refresh(); openCart(b); }); });
  // Add to cart buttons carry data-add="<variant id>". Without JS, the surrounding product form still posts to /cart/add.
  $$("[data-add]").forEach(function (b) {
    b.addEventListener("click", function (e) {
      e.preventDefault();
      var form = b.closest("form");
      var qEl = (form && $("[data-qty-value]", form)) || $("[data-qty-value]");
      add(b.getAttribute("data-add"), qEl ? (+qEl.value || +qEl.textContent || 1) : 1, b);
    });
  });
  var qOut = $("[data-qty-value]");
  $$("[data-qty]").forEach(function (b) {
    b.addEventListener("click", function () {
      var o = b.closest("form") ? $("[data-qty-value]", b.closest("form")) : qOut;
      var v = Math.max(1, Math.min(10, (+o.value || 1) + +b.getAttribute("data-qty")));
      o.value = v; if (o.tagName === "OUTPUT") o.textContent = v;
    });
  });
  refresh();

  // Gift message on Sets and gifting: saved as the cart note, which appears on the order in Shopify admin.
  $$("[data-cart-note]").forEach(function (note) {
    var status = $("[data-cart-note-status]");
    var t;
    note.addEventListener("input", function () {
      clearTimeout(t);
      t = setTimeout(function () {
        jsonFetch("cart/update.js", { method: "POST", body: JSON.stringify({ note: note.value }) })
          .then(function () { if (status) status.textContent = note.value ? "Saved. It will travel with your order." : ""; })
          .catch(function () { if (status) status.textContent = "This could not be saved. Please try again."; });
      }, 600);
    });
  });

  /* ---------- Sticky mini bar: fades in after the buy box passes ---------- */
  var sticky = $(".sticky-buy");
  var buyBox = $("#buy");
  function onScrollSticky() {
    if (!sticky || !buyBox) return;
    var r = buyBox.getBoundingClientRect();
    // Shown between the buy box and the closing sections, never over a call to action.
    var stop = $("[data-sticky-stop]") || $(".site-footer");
    sticky.classList.toggle("is-visible", r.bottom < 0 && stop.getBoundingClientRect().top > window.innerHeight);
  }

  /* ---------- Forms (prototype success states; Shopify uses customer and contact forms) ---------- */
  $$("form[data-success]").forEach(function (f) {
    f.addEventListener("submit", function (e) {
      e.preventDefault();
      if (!f.checkValidity()) { f.reportValidity(); return; }
      var msg = document.createElement("p");
      msg.className = f.getAttribute("data-success-class") || "form-success";
      msg.setAttribute("role", "status");
      msg.textContent = f.getAttribute("data-success");
      f.replaceWith(msg);
    });
  });

  onScrollHeader();
  onScrollParallax();
  onScrollCs();
  window.addEventListener("resize", function () { onScrollCs(); revealPassed(); });
})();

/* ---------- Smooth scroll, hover drift ---------- */
(function () {
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var qa = /[?&]shot=/.test(location.search);
  // Smooth scroll with gentle resistance and follow-through (desktop wheel/trackpad; touch stays native).
  if (window.Lenis && !reduce && !qa) {
    var lenis = new window.Lenis({ lerp: 0.085, wheelMultiplier: 0.9, smoothWheel: true });
    window.__lenis = lenis;
    var raf = function (t) { lenis.raf(t); requestAnimationFrame(raf); };
    requestAnimationFrame(raf);
    document.querySelectorAll('a[href^="#"]').forEach(function (a) {
      a.addEventListener("click", function (e) {
        var id = a.getAttribute("href"); if (id.length < 2) return;
        var t = document.querySelector(id); if (!t) return;
        e.preventDefault(); lenis.scrollTo(t, { offset: 0, duration: 1.6 });
      });
    });
    document.querySelectorAll(".drawer__body, .search, .menu-overlay, .mega").forEach(function (el) { el.setAttribute("data-lenis-prevent", ""); });
  }
  // Hover: image drifts toward the cursor and slowly zooms (Awaken-style), on pointer devices only.
  var sel = ".floats__item .media, .offset__art .media, .ochapter__art .media, .ccard .media, .mega__item .media, .rooted-col .media, .set__arts .media, .boxset__art .media, .bleed-split__media, .p-art .media";
  document.querySelectorAll(sel).forEach(function (el) {
    if (!el.querySelector("img")) return;
    el.setAttribute("data-hover", "");
    if (reduce || !window.matchMedia("(hover: hover)").matches) return;
    el.addEventListener("mousemove", function (e) {
      var r = el.getBoundingClientRect();
      el.style.setProperty("--mx", (((e.clientX - r.left) / r.width) - 0.5).toFixed(3) * 2);
      el.style.setProperty("--my", (((e.clientY - r.top) / r.height) - 0.5).toFixed(3) * 2);
    });
    el.addEventListener("mouseleave", function () { el.style.setProperty("--mx", 0); el.style.setProperty("--my", 0); });
  });
})();
